const steps = [
  {
    step: "1",
    title: "Cadastro",
    description: "Organização, empresas (CNPJ) e usuários com papéis RBAC.",
  },
  {
    step: "2",
    title: "Certificado A1",
    description: "Upload cifrado nos slots de homologação e produção.",
  },
  {
    step: "3",
    title: "Emitir",
    description: "Via API assíncrona ou painel operacional — webhooks avisam seu ERP.",
  },
]

export const HowItWorksSection = () => {
  return (
    <section id="como-funciona" className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="text-3xl font-bold text-slate-900">Como funciona</h2>
        <ol className="mt-10 grid gap-6 md:grid-cols-3">
          {steps.map((item) => (
            <li key={item.step} className="rounded-2xl border border-slate-200 p-6">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-600 text-sm font-bold text-white">
                {item.step}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{item.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{item.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
